module.exports = __webpack_public_path__ + "media/images/flags/16/United-Kingdom-e601f6abb4dd83954878f980e65511a7.png";